fetch('/news/index.json')
  .then(response => response.json())
  .then(data => {
      data.articles.forEach(article => {
        const li = document.createElement('li');
        li.classList.add('news__card');
        li.innerHTML = `
          <a href="${article.url}">
            <div class="news__card__img">
              <span class="news__card__in">
                <img src="${article.thumb}" alt="">
              </span>
            </div>
            <div class="news__card__text">
              <div class="news__card__date">
                ${article.published_at}
              </div>
              <p>${article.title}</p>
              <div class="news__card__bot">
                <span class="news__card__link">詳しく見る</span>
              </div>
            </div>
          </a>
        `;
        document.querySelector('.news__list').appendChild(li);
      });
  });



// WEBPACK FOOTER //
// ./src/js/news_detail.js